// Libraries
var React = require('react');

// Style
require('./GenericRichText.scss');

class GenericRichText extends React.Component { 
	constructor(props) {
		super(props);
	}

	createContent = _ => {
		return {__html: this.props.content};
	};

	render() {
		return (
			<div className={`c-richtext ${this.props.isPremium ? 'c-richtext--premium': ''} ${this.props.largeText ? 'c-richtext--large-text': ''}`} dangerouslySetInnerHTML={this.createContent()}></div>
		);
	}
};

module.exports = GenericRichText;



// WEBPACK FOOTER //
// ./src/components/RichText/GenericRichText.js